// 10% of penal amount: $50 minimum.

/* eslint-disable */
export const equation = ({ bondValue, premium, type, additional }) => {
  let value = null
  let condition = null
  let minimum = 0
  if (type === 'STATE') {
    value = (bondValue * .15)
    if (value < 20) {
      value = 20
      condition = 'Minimum not met'
    }
  }
  return { value, minimum: 20, condition }
}
/* eslint-enable */

export default equation